<template>
    <div class="cell-cover" v-if="posData.isWorkDay">
        <div class="cell h-100"
             :class="(ifSelected?'cell-active':'')+' '+(this.displayMode===3?'cell-opacity':'')"
             :style="styleStr(calDayTimeOffsetRate(null, posData.startDate,false), calDayTimeOffsetRate(posData.startDate, posData.finishDate,false))">
            <div class="cell-item-cover d-flex flex-row">
                <div class="cell-item h-100"
                     v-for="(item,index) in values"
                     :key="item.id"
                     :class="colorClass[index]"
                     :style="styleStr(rateArray[index].offset, rateArray[index].value)">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "@/components/echarts-part/CalendarShift/cells/stuffs/fade_color.css";
import {_colorTag, subMapOf} from "@/components/echarts-part/CalendarShift/cells/utils/LoadRateUtil";
import {mapState} from "vuex";

export default {
    name: "LoadRateCell",
    props: {
        locationId: String,
        dateStr: String
    },
    watch: {
        cellRecolored() {
            this.colorDisplay();
        },
        posData: {
            deep: true,
            handler() {
                this.initData();
            }
        }
    },
    computed: {
        ...mapState({
            selectedHeaderIdSet: state => state.calendarShift.selectedHeaderIdSet,
            selectedOperationId: state => state.calendarShift.selectedOperationId,
            displayMode: state => state.calendarShift.displayMode,
            cellRecolored: state => state.calendarShift.cellReColored,
            joinHeaderIdSet: state => state.calendarShift.joinHeaderIdSet,
            displayJoinHeader: state => state.calendarShift.displayJoinHeader,
            selectedOperationHeaderId: state => state.calendarShift.selectedOperationHeaderId,
        }),
        posData() {
            return this.$store.getters["calendarShift/posData"](this.position);
        },
        normalColor() {
            //小于当前时间的超出负荷，就不报红了
            return this.posData !== undefined && new Date(Date.parse(this.posData.startDate)) >= new Date() && this.posData.workingHoursActual > this.posData.workingHoursAbility ? 'cl-red' : 'cl-orange';
        },
        ifSelected() {
            let pos = this.$store.state.calendarShift.itemPos;
            return pos !== null && pos.locationId === this.locationId && pos.dateStr === this.dateStr;
        },
        operationMap() {
            return this.$store.getters["calendarShift/operationMap"];
        }
    },
    data() {
        return {
            values: [],
            position: {
                locationId: this.locationId,
                dateStr: this.dateStr
            },
            colorClass: [],
            rateArray: [],
            length: 864000
        }
    },
    mounted() {
        this.initData()
    },
    methods: {
        cellClick() {
            if (this.displayMode === 3) {
                this.$store.commit('calendarShift/setTargetPos', this.position);
            } else if (this.posData.isWorkDay) {
                this.$emit('cellClick');//防止点击空表格
            }
        },
        initData() {
            let dayMap = subMapOf(this.posData);
            if (dayMap != null) {
                this.values = dayMap;
            } else {
                this.values = [];
            }
            this.length = this.calTimeBetween(this.posData.startDate, this.posData.finishDate) / 100;
            this.colorDisplay()
            this.initRateArray()
        },
        colorDisplay() {
            if (this.values.length > 0) {
                let temp = [];
                for (let item of this.values) {
                    let tag = 1;
                    if (this.displayJoinHeader && !this.joinHeaderIdSet.has(item.headerId)) {
                        tag = 7;
                    } else {
                        if (item.posIdOperation === this.selectedOperationId) {
                            tag *= 2;
                        }
                        if (this.selectedHeaderIdSet.has(item.headerId)) {
                            tag *= 3;
                        }
                        if (this.displayMode === 4 && this.operationMap[item.posIdOperation].isLocked !== undefined && this.operationMap[item.posIdOperation].isLocked === true) {
                            tag *= 5;
                        }
                        if (this.selectedHeaderIdSet.size > 1 && item.posIdOperation !== this.selectedOperationId && this.selectedOperationHeaderId === item.headerId) {
                            tag *= 11;
                        }
                    }
                    let color = _colorTag(tag);
                    if (color === undefined) {
                        color = this.normalColor;
                    }
                    temp.push(color);
                }
                this.colorClass = temp;
            }
        },
        initRateArray() {
            let valTemp = [];
            let preTime = this.posData.startDate;
            for (let item of this.values) {
                valTemp.push({
                    offset: this.calDayTimeOffsetRate(preTime, item.posForecastBeginTime, true),
                    value: this.calDayTimeOffsetRate(item.posForecastBeginTime, item.posForecastEndTime, true)
                });
                preTime = item.posForecastEndTime;
            }
            this.rateArray = valTemp;
        },
        styleStr(ml, w) {
            return 'margin-left:' + ml + '%; width:' + w + '%; '
        },
        calDayTimeOffsetRate(f, t, inner) {
            if (f == null) {
                f = this.posData.dateStr + ' 00:00:00';
            }
            return this.calTimeBetween(f, t) / (inner ? this.length : 864000);
        },
        calTimeBetween(f, t) {
            return new Date(t).getTime() - new Date(f).getTime();
        }
    }
}
</script>

<style scoped>
.cell-cover {
    height: 30px;
    width: 60px;
}

.cell {
    border-radius: 5px;
    overflow: auto;
    margin: 0 auto 0 0;
    background-color: #f5f5f5;
    transition: .2s ease-out;
}

.cell:hover {
    box-shadow: 0 0 0 .2rem rgba(255, 165, 0, .7);
    opacity: 1 !important;
}

.cell-item-cover {
    height: 100%;
    width: 100%;
    overflow: hidden;
    max-width: 60px;
    animation: ani-width .3s linear;
}

@keyframes ani-width {
    from {
        max-width: 0;
    }
}

.cell-active {
    box-shadow: 0 0 0 .15rem rgba(255, 165, 0, .4)
}

.cell-opacity {
    opacity: 0.6;
}

.cell-item {
}

</style>